import RouteConstants from '@/features/router/RouteConstants';
import { AudiencesIcon, CampaignIcon, DataSourcesIcon, DestinationsIcon, HomeIcon } from '@/lib/Icons';
import type { IconProps } from '@/lib/Icons/Icons/types';
import { createElement } from 'react';
import { LuBrainCircuit, LuChartBar, LuLandmark } from 'react-icons/lu';
import { NavSidebarItemData } from './components/SidebarBase/SidebarNavigation/Items/NavSidebarItem/types';

const MarketingIntelligenceSidebarIcon = ({ className }: IconProps) => createElement(LuBrainCircuit, { className });
const CampaignPerformanceSidebarIcon = ({ className }: IconProps) => createElement(LuChartBar, { className });
const ComuniSidebarIcon = ({ className }: IconProps) => createElement(LuLandmark, { className });

export const SIDEBAR_CONFIG: ReadonlyArray<NavSidebarItemData> = [
  {
    icon: HomeIcon,
    path: RouteConstants.home,
    title: 'home',
  },
  {
    icon: MarketingIntelligenceSidebarIcon,
    path: RouteConstants.marketIntellingence,
    title: 'marketIntelligence',
  },
  {
    icon: DataSourcesIcon,
    path: RouteConstants.dataSources,
    title: 'dataSource_other',
  },
  {
    icon: AudiencesIcon,
    path: RouteConstants.audiences,
    title: 'audience_other',
  },
  {
    icon: DestinationsIcon,
    path: RouteConstants.destinations,
    title: 'destination_other',
  },
  {
    icon: CampaignIcon,
    path: RouteConstants.campaigns,
    title: 'campaign_other',
  },
  {
    icon: ComuniSidebarIcon,
    path: RouteConstants.comuni,
    title: 'comuni',
    isNew: false,
  },
  {
    icon: CampaignPerformanceSidebarIcon,
    path: RouteConstants.campaignPerformance,
    title: 'campaignPerformance',
  },
] as const;
